// Mock data for Kibbles & Bits of Kindness

export const mockData = {
  organization: {
    name: "Kibbles & Bits of Kindness",
    location: "Airdrie, Alberta",
    serviceArea: "Airdrie and surrounding areas",
    mission: "Helping local families keep their beloved pets by providing essential supplies and support, ensuring no four-legged family member ends up in a shelter or on the streets.",
    emails: {
      general: "hello@bitsofkindness.ca",
      donations: "beahero@bitsofkindness.ca",
      volunteer: "kindnesscrew@bitsofkindness.ca",
      gethelp: "gethelp@bitsofkindness.ca"
    },
    social: {
      facebook: "https://www.facebook.com/profile.php?id=61584679302598",
      instagram: "https://www.instagram.com/kbk.community/"
    }
  },
  services: [
    {
      id: 1,
      title: "Pet Food Pantry",
      description: "Free pet food distribution for families in need. We provide quality food for dogs, cats, and other household pets.",
      icon: "heart"
    },
    {
      id: 2,
      title: "Donation Collection",
      description: "Accepting donations of pet supplies, food, toys, bedding, and more to help local pets stay happy and healthy.",
      icon: "package"
    },
    {
      id: 3,
      title: "Emergency Pet Support",
      description: "Providing assistance during difficult times to ensure pets can remain with their loving families.",
      icon: "shield"
    }
  ],
  donationItems: [
    {
      category: "Pet Food",
      items: [
        "Dry dog food (all sizes & stages)",
        "Dry cat food (all sizes & stages)",
        "Wet/canned dog food",
        "Wet/canned cat food",
        "Milk replacer (baby cats & dogs)",
        "Special diet food (grain-free, sensitive stomach)",
        "Food for small animals (bunnies, hamsters, etc.)",
        "Treats"
      ]
    },
    {
      category: "Pet Supplies",
      items: [
        "Leashes, collars, harnesses, ID tags",
        "Muzzles",
        "Toys: chew toys, puzzle toys, teething toys",
        "Lick mats / snuffle mats",
        "Clickers, Thunder shirts / calming wraps",
        "Litter boxes & scoops",
        "Cat Litter (including wood pellets)",
        "Food & water bowls (all kinds, non-slip & elevated)",
        "Kennels, crates, play pens",
        "Tarps / floor protectors",
        "Heaters & fans",
        "Outdoor dog houses (winter-rated)",
        "Heated pet bowls",
        "Blankets/sheets & towels",
        "Straw",
        "Pet beds",
        "Whelping / nesting / birthing boxes",
        "Camera or baby monitors for whelping, etc."
      ]
    },
    {
      category: "Medical & Hygiene",
      items: [
        "Pet shampoo",
        "Brushes",
        "Dental care items",
        "First aid supplies",
        "Pet waste bags",
        "Training pads/puppy pads",
        "Disposable gloves",
        "Heating mats",
        "Cooling mats",
        "Thermometers, syringes (no needle) & pill pockets",
        "Elizabethan collars (cones) & bandage wraps",
        "Flea combs / tick removal tools",
        "Unscented baby / puppy wipes",
        "Pee-resistant mattress protectors",
        "Calming sprays"
      ]
    },
    {
      category: "Other / Household & Donations",
      items: [
        "Monetary donations (E-transfer: beahero@bitsofkindness.ca)",
        "Storage containers & shelving",
        "Dawn dish soap",
        "Laundry detergent",
        "Bleach, general cleaning supplies",
        "Paper towels",
        "Labels, ziplock bags, sharpies / tape"
      ]
    }
  ],
  aboutUs: {
    story: "Kibbles & Bits of Kindness was founded on the belief that pets are family, and no one should have to choose between keeping their beloved companion and meeting their basic needs. We understand that life can be challenging, and sometimes families need a helping hand to care for their four-legged family members.",
    mission: "Our mission is simple: keep pets in loving homes. By providing food, supplies, and support to families in Airdrie and surrounding areas, we work to prevent pets from ending up in shelters or, worse, on the streets. Every donation we receive goes directly to helping local pets stay safe, healthy, and happy with the families who love them.",
    location: "Based in Airdrie, Alberta, we proudly serve our local community first, then extend our support to surrounding areas as resources allow."
  },
  volunteer: {
    status: "coming_soon",
    message: "We're currently building our volunteer program! Right now, we're looking for dedicated individuals who can help with picking up and transporting donated items. Check back soon for more opportunities to get involved.",
    contactEmail: "volunteer@kibblesandbitsofkindness.org"
  }
};
